import axios from "axios";
import React, { useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "../../../components/commonComponent/Customform.js";
import "../../../styles/Form.css";
import AWS from "../../../utils/awsConfig.js";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  { label: "Date", name: "date", placeholder: "Select Date", required: true ,type:"date"},
  { label: "Slug", name: "slug", placeholder: "Enter Slug"},
  {
    label: "Brief Description",
    name: "briefDescription",
    placeholder: "Enter brief description",
    required: true,
  },
  {
    label: "Meta Title",
    name: "metaTitle",
    placeholder: "Enter Meta Title",
    required: true,
  },
  {
    label: "Meta Description",
    name: "metaDescription",
    placeholder: "Enter Meta Description",
    required: true,
  },
  {
    label: "Keywords",
    name: "keywords",
    placeholder: "Enter Comma Seprated keywords",
    required: true,
  },
  {
    label: "Is Featured",
    name: "isFeatured",
    type: "select", // Important for single select
    options: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],
  },
  
  {
    label: "Description",
    name: "description",
    placeholder: "Enter description",
    type: "rich-text",
    required: true,
  },
  {
    label: "Tags",
    name: "tags",
    placeholder: "Add tags",
    required: true,
  },
  {
    label: "Images",
    name: "images",
    placeholder: "Choose Images",
    type: "file",
    multiple: true,
  },
  {
    label: "Read Time",
    name: "readtime",
    placeholder: "e.g. 3 ",
    required: true,
  },
  {
    label: "Product category",
    name: "productcategory",
    placeholder: "Select category",
    isMultifield: true,
  },
  {
    label: "Blog category",
    name: "blogcategory",
    placeholder: "Select category ",
    isMultifield: true,
  },
];

const AddBlob = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const [initialValues, setInitialValues] = useState({});

  const generateSlug = (title) =>
  title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // remove special characters
    .replace(/\s+/g, "-")     // replace spaces with hyphens
    .replace(/--+/g, "-");    // replace multiple hyphens


useEffect(() => {
  const draft = sessionStorage.getItem("generatedBlog");
  if (draft) {
    const parsed = JSON.parse(draft);
    const autoSlug = parsed.title ? generateSlug(parsed.title) : "";

    setInitialValues({
      title: parsed.title || "",
      slug: autoSlug,
      briefDescription: parsed.briefDescription || "",
      description: parsed.description || "",
    });

    sessionStorage.removeItem("generatedBlog");
  }
}, []);




const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};

const handleSubmit = async (formData) => {
  try {
    if (imageFiles.length > 0) {
      const uploadedImageUrls = await Promise.all(
        imageFiles.map((file) => handleImageUpload(file))
      );
      formData.images = uploadedImageUrls;
    }

    // 👉 Format readtime (e.g., 5 → "5 min read")
    const formattedReadTime = formData.readtime
      ? `${formData.readtime.toString().replace(/\D/g, "")} min read`
      : `${Math.floor(Math.random() * 5) + 1} min read`; // optional fallback if needed

    const transformedData = {
      ...formData,
      readtime: formattedReadTime,
      blogcategory: formData.blogcategory?.map((item) => item.value) || [],
      productcategory: formData.productcategory?.map((item) => item.value) || [],
    };

    console.log("Transformed Data: ", transformedData);

    const response = await axios.post(`${API_URL}/blogs/addBlog`, transformedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200 || response.status === 201) {
      toast.success("Data added successfully", {
        autoClose: 1000,
      });
      navigate("/blogManagement");
    } else {
      throw new Error("Unexpected server response");
    }
  } catch (error) {
    console.error("Error adding data: ", error);
    const errorMessage =
      error.response?.data?.message || "Error adding data. Please try again.";
    toast.error(errorMessage, {
      autoClose: 1000,
    });
  }
};

  
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setImageFiles(files);
      const previews = files.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  console.log("imageFiles ", imageFiles, imagePreviews);

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Blog
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/blogManagement")}
        >
          &times;
        </button>
      </div>
     <Customform
  mode={MODE.ADD}
  onSubmit={handleSubmit}
  fields={fields}
  initialValues={initialValues} // 👈 prefill comes here
  imagePreview={imagePreviews}
  handleCustomerImageChange={handleImageChange}
/>
    </div>
  );
};

export default AddBlob;
